import { useState, useEffect } from 'react';

export default function useSortPreference(storageKey, options = {}) {
  const { defaultCol = null, defaultDir = 'asc' } = options;
  const [sortCol, setSortCol] = useState(defaultCol);
  const [sortDir, setSortDir] = useState(defaultDir);

  useEffect(() => {
    if (!storageKey) {
      setSortCol(defaultCol);
      setSortDir(defaultDir);
      return;
    }
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        const { col, dir } = JSON.parse(saved);
        setSortCol(col ?? defaultCol);
        setSortDir(dir === 'desc' ? 'desc' : 'asc');
        return;
      } catch {
        // fall through to defaults
      }
    }
    setSortCol(defaultCol);
    setSortDir(defaultDir);
  }, [storageKey, defaultCol, defaultDir]);

  const handleSort = (col) => {
    const nextCol = col;
    const nextDir = sortCol === col && sortDir === 'asc' ? 'desc' : 'asc';
    setSortCol(nextCol);
    setSortDir(nextDir);
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify({ col: nextCol, dir: nextDir }));
    }
  };

  return { sortCol, sortDir, handleSort };
}
